(function () {
  const cache = {};

  function resolveLocaleUrl(url, locale) {
    const code = (locale || 'es').split('-')[0].toLowerCase();
    if (!code || code === 'es') return url;
    if (new RegExp('\\.' + code + '\\.json', 'i').test(url)) return url;
    return url.replace(/\.json(\?.*)?$/, '.' + code + '.json');
  }

  async function loadData(url) {
    if (cache[url]) return cache[url];
    const res = await fetch(url);
    if (!res.ok) throw new Error('Storytelling fetch failed');
    cache[url] = await res.json();
    return cache[url];
  }

  async function loadLocalized(url, locale) {
    const localized = resolveLocaleUrl(url, locale);
    if (localized !== url) {
      try {
        const res = await fetch(localized);
        if (res.ok) {
          cache[localized] = await res.json();
          return cache[localized];
        }
      } catch (e) {}
    }
    return loadData(url);
  }

  async function initBlock(block) {
    const handle = block.dataset.productHandle;
    const dataUrl = block.dataset.storytellingUrl;
    const headingEl = block.querySelector('[data-storytelling-heading]');
    const bodyEl = block.querySelector('[data-storytelling-body]');
    if (!handle || !dataUrl || !bodyEl) return;

    try {
      const data = await loadLocalized(dataUrl, block.dataset.locale);
      const entry = data[handle];
      if (!entry || !entry.body) {
        block.hidden = true;
        return;
      }
      if (headingEl && entry.heading) {
        headingEl.textContent = entry.heading;
      }
      bodyEl.textContent = entry.body;
    } catch (e) {
      block.hidden = true;
    }
  }

  function boot() {
    document.querySelectorAll('.product-storytelling[data-product-handle]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
